/**
 * Consistent console page chrome — title, live/demo badge, subtitle metrics, actions.
 */
export function PageShell({ title, subtitle, live, loading, actions, children, className = "" }) {
  return (
    <div className={`console-page ${className}`.trim()}>
      <header className="page-header">
        <div className="page-header-main">
          <div className="page-title-row">
            <h1 className="page-title">{title}</h1>
            {live !== undefined && (
              <span className={`page-badge ${live ? "page-badge-live" : "page-badge-demo"}`}>
                {live ? "Live" : "Demo"}
              </span>
            )}
            {loading && <span className="page-sync">Syncing…</span>}
          </div>
          {subtitle ? <p className="page-sub">{subtitle}</p> : null}
        </div>
        {actions ? <div className="page-actions">{actions}</div> : null}
      </header>
      {children}
    </div>
  );
}
